module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal-lost-integrations"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row description"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.deal_lost')) + ":")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox-inline checkbox-update",
    on: {
      "click": function($event) {
        return _vm.sending_checked('update_deal_lost')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "mark_as"
    },
    domProps: {
      "checked": _vm.update_deal_lost
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.actions.update.deal_lost.update')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox-inline checkbox-update",
    on: {
      "click": function($event) {
        return _vm.sending_checked('not_update_deal_lost')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "mark_as"
    },
    domProps: {
      "checked": _vm.not_update_deal_lost
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.actions.update.deal_lost.notUpdate')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dbade28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/deal_lost.vue
// module id = 1081
// module chunks = 1